import { pathOr } from 'ramda';

import { IApplicationState } from '../../types/redux';

export const getFirstName = (state: IApplicationState): string | undefined => {
  return pathOr(undefined, ['user', 'firstName'], state);
};
